// Set of helper functions to facilitate wallet setup
// Set of helper functions to facilitate wallet setup

/**
 * Prompt the user to add BSC as a network on Metamask, or switch to BSC if the wallet is on a different network
 * Prompt the user to add BSC as a network on Metamask, or switch to BSC if the wallet is on a different network
 * @returns {boolean} true if the setup succeeded, false otherwise
 */
import { connectorsByName } from "../utils/web3React";
export const setupNetwork = async (v) => {
  let provider = "";
  // connectorsByName
  // console.log(provider, "providerproviderprovider");
  // connectorsByName
  // console.log(provider, "providerproviderprovider");
  const connectorId =
    typeof window !== "undefined"
      ? window.localStorage.getItem("connectorId")
      : null;
  if (connectorId === "injected") {
    provider = window.ethereum;
  } else {
    if (connectorsByName.walletconnect.provider) {
      provider = connectorsByName.walletconnect.provider;
    }
  }

  if (provider) {
    // const chainId = parseInt(v, 10)
    const CHAIN = process.env.REACT_APP_CHAIN_ID;
    const chainId = CHAIN;
    // const chainId = 11155111;
    try {
      console.log("Switching network to chainId:", chainId);
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [
          {
            chainId: `0x${chainId.toString(16)}`,
          },
        ],
      });
      return true;
    } catch (error) {
      console.log("Error switching network:", error);
      if (error.code === 4902) {
        try {
          await provider.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: "0xa4b1", // 42161
                chainName: "Arbitrum One",
                nativeCurrency: {
                  name: "ETH",
                  symbol: "ETH",
                  decimals: 18,
                },
                rpcUrls: [
                  "https://dry-quiet-sound.arbitrum-mainnet.quiknode.pro/ec48bb1798a955bcdf75c64bc9fab428add0745e/",
                ],
                blockExplorerUrls: ["https://arbiscan.io/"],
              },
            ],
          });
          return true;
        } catch (addError) {
          console.error("Failed to add Arbitrum:", addError);
          return false;
        }
      }

      console.error("Switch chain failed:", error);
      return false;
    }
  } else {
    console.error(
      "Can't setup the BSC network on metamask because window.ethereum is undefined",
    );
    return false;
  }
};
/**
 * Prompt the user to add a custom token to metamask
 * @param tokenAddress
 * @param tokenSymbol
 * @param tokenDecimals
 * @param tokenImage
 * @returns {boolean} true if the token has been added, false otherwise
 */
export const registerToken = async (
  tokenAddress,
  tokenSymbol,
  tokenDecimals,
  tokenImage,
) => {
  const tokenAdded = await window.ethereum.request({
    method: "wallet_watchAsset",
    params: {
      type: "ERC20",
      options: {
        address: tokenAddress,
        symbol: tokenSymbol,
        decimals: tokenDecimals,
        image: tokenImage,
      },
    },
  });

  return tokenAdded;
};

// // Set of helper functions to facilitate wallet setup for Sepolia testnet

// /**
//  * Prompt the user to add Sepolia as a network on Metamask, or switch to Sepolia if the wallet is on a different network
//  * @returns {boolean} true if the setup succeeded, false otherwise
//  */
// import { connectorsByName } from "../utils/web3React";

// const CHAIN = process.env.REACT_APP_CHAIN_ID;

// const NETWORK_PARAMS = {
//   1: {
//     chainName: "Ethereum Mainnet",
//     nativeCurrency: {
//       name: "Ether",
//       symbol: "ETH",
//       decimals: 18,
//     },
//     rpcUrls: [
//       "https://cold-responsive-friday.quiknode.pro/15bbbcf85ec27b075486f39524c5741f49222932/",
//     ],
//     blockExplorerUrls: ["https://etherscan.io/"],
//   },
//   11155111: {
//     chainName: "Sepolia Test Network",
//     nativeCurrency: {
//       name: "SepoliaETH",
//       symbol: "ETH",
//       decimals: 18,
//     },
//     rpcUrls: [
//       "https://eth-sepolia.g.alchemy.com/v2/n_4iaIl35yi2Vc0AV3-eg9rsdbG95Tfg",
//       "https://sepolia.infura.io/v3/",
//       "https://rpc.sepolia.org",
//       "https://ethereum-sepolia.blockpi.network/v1/rpc/public",
//     ],
//     blockExplorerUrls: ["https://sepolia.etherscan.io/"],
//   },
//   42161: {
//     chainName: "Arbitrum One",
//     nativeCurrency: {
//       name: "ETH",
//       symbol: "ETH",
//       decimals: 18,
//     },
//     rpcUrls: [
//       "https://dry-quiet-sound.arbitrum-mainnet.quiknode.pro/ec48bb1798a955bcdf75c64bc9fab428add0745e/",
//     ],
//     blockExplorerUrls: ["https://arbiscan.io/"],
//   },
// };

// export const setupNetwork = async () => {
//   let provider = "";

//   const connectorId =
//     typeof window !== "undefined"
//       ? window.localStorage.getItem("connectorId")
//       : null;

//   if (connectorId === "injected") {
//     provider = window.ethereum;
//   } else {
//     if (connectorsByName.walletconnect.provider) {
//       provider = connectorsByName.walletconnect.provider;
//     }
//   }

//   if (provider) {
//     const chainId = parseInt(CHAIN, 10); // CHAIN ID from .env

//     try {
//       // First try to switch to CHAIN
//       await provider.request({
//         method: "wallet_switchEthereumChain",
//         params: [
//           {
//             chainId: `0x${chainId.toString(16)}`,
//           },
//         ],
//       });
//       return true;
//     } catch (switchError) {
//       // This error code indicates that the chain has not been added to MetaMask
//       if (switchError.code === 4902) {
//         try {
//           // Add Sepolia network to MetaMask
//           await provider.request({
//             method: "wallet_addEthereumChain",
//             params: [
//               {
//                 chainId: `0x${chainId.toString(16)}`, // 0xaa36a7
//                 ...NETWORK_PARAMS[chainId],
//               },
//             ],
//           });
//           return true;
//         } catch (addError) {
//           console.error("Failed to add Sepolia network:", addError);
//           return false;
//         }
//       } else {
//         console.error("Failed to switch to Sepolia network:", switchError);
//         return false;
//       }
//     }
//   } else {
//     console.error(
//       "Can't setup the Sepolia network on metamask because window.ethereum is undefined",
//     );
//     return false;
//   }
// };

// /**
//  * Prompt the user to add a custom token to metamask on Sepolia network
//  * @param tokenAddress - The contract address of the token on Sepolia
//  * @param tokenSymbol - The symbol of the token (e.g., "USDC")
//  * @param tokenDecimals - The number of decimals the token uses (usually 18)
//  * @param tokenImage - URL to the token's logo image
//  * @returns {boolean} true if the token has been added, false otherwise
//  */
// export const registerToken = async (
//   tokenAddress,
//   tokenSymbol,
//   tokenDecimals,
//   tokenImage,
// ) => {
//   try {
//     const tokenAdded = await window.ethereum.request({
//       method: "wallet_watchAsset",
//       params: {
//         type: "ERC20",
//         options: {
//           address: tokenAddress,
//           symbol: tokenSymbol,
//           decimals: tokenDecimals,
//           image: tokenImage,
//         },
//       },
//     });

//     return tokenAdded;
//   } catch (error) {
//     console.error("Failed to add token to wallet:", error);
//     return false;
//   }
// };

// /**
//  * Helper function to verify if the current network is Sepolia
//  * @returns {boolean} true if connected to Sepolia, false otherwise
//  */
// export const isSepoliaNetwork = async () => {
//   if (typeof window !== "undefined" && window.ethereum) {
//     try {
//       const chainId = await window.ethereum.request({ method: "eth_chainId" });
//       return chainId === "0xaa36a7"; // Sepolia chain ID in hex
//     } catch (error) {
//       console.error("Failed to get chain ID:", error);
//       return false;
//     }
//   }
//   return false;
// };

// /**
//  * Get Sepolia network configuration
//  * @returns {object} Sepolia network configuration object
//  */
// export const getSepoliaConfig = () => {
//   return {
//     chainId: 1,
//     chainIdHex: "0xaa36a7",
//     chainName: "Sepolia Test Network",
//     nativeCurrency: {
//       name: "SepoliaETH",
//       symbol: "ETH",
//       decimals: 18,
//     },
//     rpcUrls: [
//       "https://sepolia.infura.io/v3/",
//       "https://rpc.sepolia.org",
//       "https://ethereum-sepolia.blockpi.network/v1/rpc/public",
//     ],
//     blockExplorerUrls: ["https://sepolia.etherscan.io/"],
//   };
// };
